<template>
    <el-container>
        <el-aside v-if="!this.$route.query.tc && isAuthenticated">
            <aside-comp></aside-comp>
        </el-aside>
        <el-container class="custom-body" style="flex-direction: column; flex-wrap: nowrap; height: 100vh;">
            <router-view/>
        </el-container>
    </el-container>
</template>

<style>
</style>

<script src="./App.js">
</script>
